
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/privateAppsPanel/components/appReadme/appReadme.scss.css.virtualfile';
        module.exports = {"content":"_content_1sutk_1","container":"_container_1sutk_4"};